/**
 * @author he jia
 * @date 2025-03-27
 * @description AI教学行为分析
 */

import { lazy } from 'react';
const AiCourseEvaluation = [
    {
        label: '分析页',
        key: 'ai-course-evaluate-analysis',
        path: '/ai-course-evaluate-analysis',
        show: true,
        element: lazy(() => import('@/page/AiCourseEvaluation/Analysis'))
    },
    {
        label: '',
        key: 'ai-course-evaluate-rating-report-parent',
        show: false,
        path: '/ai-course-evaluate-rating-report/:id',
        element: lazy(() => import('src/components/Layout/CommonLayout')),
        children: [
            {
                label: '评课报告',
                key: 'ai-course-evaluate-rating-report',
                path: '/ai-course-evaluate-rating-report/:id',
                show: false,
                element: lazy(() => import('@/page/AiCourseEvaluation/AiRatingReport'))
            }
        ]
    },

    {
        label: '评课报告',
        key: 'ai-course-evaluate-report',
        path: '/public/ai-course-evaluate-report/:id/:type',
        show: true,
        element: lazy(() => import('@/page/AiCourseEvaluation/AiReport'))
    },
    {
        label: '创建页',
        key: 'ai-course-evaluate-create',
        path: '/ai-course-evaluate-create',
        show: true,
        element: lazy(() => import('@/page/AiCourseEvaluation/Create'))
    }
];
export default AiCourseEvaluation;
